import * as React from 'react';
import styles from './secondary-button.module.scss';

export interface ButtonSecondaryProps {
    label: string;
    disabled?: boolean;
    className?: string;
    color?: ButtonColor;
    onClick: () => void;
}

export enum ButtonColor {
    Gray,
    White,
}

export const ButtonSecondary: React.FunctionComponent<ButtonSecondaryProps> = ({ onClick, label, disabled = false, className, color }) => {
    const handleClick = (e: React.MouseEvent) => {
        e.stopPropagation();
        !disabled && onClick && onClick();
    };

    const classes = [styles.button];
    if (disabled) {
        classes.push(styles.disabled);
    }
    if (className) {
        classes.push(className);
    }

    switch (color) {
        case ButtonColor.Gray:
            classes.push(styles['gray-color']);
            break;
        case ButtonColor.White:
            classes.push(styles['white-color']);
            break;
        default:
            break;
    }
    return (
        <button className={classes.join(' ')} onClick={handleClick}>
            {label}
        </button>
    );
};
